import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController } from 'ionic-angular';
import { AddorarioPage } from '../../pages/addorario/addorario';
import { EditorarioPage } from '../../pages/editorario/editorario';

import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the OrarioPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-orario',
  templateUrl: 'orario.html',
})
export class OrarioPage {
  orari: any;
  stato;
  info;
  errorMessage: string;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider, private alertCtrl: AlertController,

  ) {
   

  }
  chiudi(){
    let alert = this.alertCtrl.create({
      title: "Chiusura",
      message: "Sei sicuro di volor chiudere il negozio?",
      enableBackdropDismiss: false, // <- Here! :)

      buttons: [
      
        {
          text: 'Annulla',
          role: 'cancel',

        },
        {
          text: 'Conferma',
          handler: () => {
            this.info.aperto=false;
            this.rest.updateApertura(this.info);
            //this.navCtrl.push(ImpostazionePage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });;
            let hideFooterTimeout1 = setTimeout(() => {
              this.infoStoreToday();
            }, 2000);
           // this.navCtrl.setRoot(ImpostazionePage);
          }
        }
      ],
    });
    alert.present();

  }
  apri(){
    let alert = this.alertCtrl.create({
      title: "Chiusura",
      message: "Sei sicuro di volor aprire il negozio?",
      enableBackdropDismiss: false, // <- Here! :)

      buttons: [
      
        {
          text: 'Annulla',
          role: 'cancel',

        },
        {
          text: 'Conferma',
          handler: () => {
            this.info.aperto=true;
            this.rest.updateApertura(this.info);
           // this.navCtrl.push(ImpostazionePage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });;
           let hideFooterTimeout1 = setTimeout(() => {
            this.infoStoreToday();
          }, 2000);
           //this.navCtrl.setRoot(ImpostazionePage);
          }
        }
      ]
    });
    alert.present();
  }
  getInfoRistorante() {
    this.rest.getInfoRistorante()
      .subscribe(
        info => this.info = info,
        error => this.errorMessage = <any>error);

    console.log("infoRistorante:" + JSON.stringify(this.info));
  }

  infoStoreToday() {

    this.rest.infoStoreToday().subscribe(
      stato => this.stato = stato,
      error => this.errorMessage = <any>error);
  }
  getOrari() {
    this.rest.getGiornoConsegnaList().subscribe(
      orari => this.orari = orari,
      error => this.errorMessage = <any>error);
  }

  ionViewDidLoad() {
    this.getOrari();
    this.infoStoreToday();
    this.getInfoRistorante();
    console.log('ionViewDidLoad OrarioPage');
  }
  openAddorarioPage() {
    if (this.orari.length == 7) { alert('Ci sono tutti i giorni della settimana'); }
    else {
      this.navCtrl.push(AddorarioPage, { orari: this.orari });
    }
  }
  openEditorarioPage(orario){
    this.navCtrl.push(EditorarioPage, { orario: orario, orari: this.orari });

  }
}



// WEBPACK FOOTER //
// ./src/pages/orario/orario.ts